import { render } from "./checkStandard.vue?vue&type=template&id=4c09d287&scoped=true&ts=true"
import script from "./checkStandard.vue?vue&type=script&lang=ts"
export * from "./checkStandard.vue?vue&type=script&lang=ts"

import "./checkStandard.vue?vue&type=style&index=0&id=4c09d287&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c09d287"]])

export default __exports__